import { render, staticRenderFns } from "./ConfigurazionePazientiMenuView.vue?vue&type=template&id=19975875"
import script from "./ConfigurazionePazientiMenuView.vue?vue&type=script&lang=js"
export * from "./ConfigurazionePazientiMenuView.vue?vue&type=script&lang=js"
import style0 from "./ConfigurazionePazientiMenuView.vue?vue&type=style&index=0&id=19975875&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports